module.exports = __webpack_public_path__ + "static/img/Simulations 1 - Semi-analytical propagation.5e7b7a0.png";